var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestionRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_7507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.172852C4.44316 0.172852 0.75 3.86602 0.75 8.42285C0.75 12.9797 4.44316 16.6729 9 16.6729C13.5568 16.6729 17.25 12.9797 17.25 8.42285C17.25 3.86602 13.5568 0.172852 9 0.172852ZM9 15.126C5.30361 15.126 2.29688 12.1189 2.29688 8.42285C2.29688 4.72679 5.30361 1.71973 9 1.71973C12.6964 1.71973 15.7031 4.72679 15.7031 8.42285C15.7031 12.1189 12.6964 15.126 9 15.126ZM9 11.001C8.41992 11.001 7.96875 11.4521 7.96875 12.0322C7.96875 12.6123 8.39092 13.0635 9 13.0635C9.55107 13.0635 10.0312 12.6123 10.0312 12.0322C10.0312 11.4521 9.55107 11.001 9 11.001ZM10.0667 4.29785H8.41992C7.16309 4.29785 6.16406 5.29688 6.16406 6.55371C6.16406 6.97266 6.51855 7.32715 6.9375 7.32715C7.35645 7.32715 7.71094 6.97266 7.71094 6.55371C7.71094 6.16699 8.0042 5.84473 8.39092 5.84473H10.0377C10.4534 5.84473 10.8047 6.16699 10.8047 6.55371C10.8047 6.81152 10.6758 7.00811 10.4502 7.13701L8.61328 8.26172C8.35547 8.42285 8.22656 8.68066 8.22656 8.93848V9.4541C8.22656 9.87305 8.58105 10.2275 9 10.2275C9.41895 10.2275 9.77344 9.87305 9.77344 9.4541V9.38965L11.2269 8.4873C11.9036 8.06836 12.3226 7.32715 12.3226 6.55371C12.3516 5.29688 11.3525 4.29785 10.0667 4.29785Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_7507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(0.75 0.172852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionRegular);
export default __webpack_public_path__ + "static/media/circle-question-regular.87dc33fa40ca7878ec6ad4307b277e5a.svg";
export { ForwardRef as ReactComponent };